export default {
  listFeedbacks: document.querySelector('.js-list-feedbacks'),
  leaveFeedbackBtn: document.querySelector('.btn-feedback-modal'),

  // Artists
  listArtists: document.querySelector('.artists-list'),
  loadMoreArtistsBtn: document.querySelector('.js-load-more-btn'),
  loaderArtists: document.querySelector('.artists-list-wrapper .loader'),

  //headr
  menu: document.querySelector('[data-menu]'),
  toggleBtn: document.querySelector('[data-menu-toggle]'),
  navLinks: document.querySelectorAll('.nav-list a'),
  // scroll-up

  scrollUpBtn: document.querySelector('.js-scroll-up'),
};
